export default function getDispatch(typeValue, dataValue) {
  return {
    type: typeValue,
    payload: dataValue.data,
  };
}
